import React, { useEffect, useState } from 'react';

import { Row, Col } from 'xpi-black-ui/Base/Grid';
import Button from 'xpi-black-ui/Base/Button';

import waConfig from 'utils/waConfig';
import { Container } from './styles';

function Footer({ hasPrice, saveQuote, isQuoteUpdate }) {
  const [enableSaveQuote, setEnableSaveQuote] = useState(false);

  useEffect(() => {
    setEnableSaveQuote(hasPrice);
  }, [hasPrice]);

  return (
    <Container>
      <Row justifyContent="flex-end">
        <Col>
          <Button
            primary
            disabled={!enableSaveQuote}
            onClick={() => saveQuote()}
            data-wa={waConfig.event.customQuotes.quote}
          >
            {isQuoteUpdate
              ? 'Salvar cotação'
              : 'Armazenar cotação'
            }
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
